/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Goals_TailInputs */

const en_for_whom_goals_tail = /** @type {(inputs: For_Whom_Goals_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this is how you get it.`)
};

const pl_for_whom_goals_tail = /** @type {(inputs: For_Whom_Goals_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z tym tu wygrywasz.`)
};

/**
* | output |
* | --- |
* | "this is how you get it." |
*
* @param {For_Whom_Goals_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_goals_tail = /** @type {((inputs?: For_Whom_Goals_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Goals_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_goals_tail(inputs)
	return en_for_whom_goals_tail(inputs)
});